import { z } from 'zod'

import {
  EmailAddressSchema,
  TimestampSchema,
  UserIdSchema,
} from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

export const ProfileSchema = z.object({
  userId: UserIdSchema,
  emailAddress: EmailAddressSchema,
  firstName: z.string(),
  lastName: z.string(),
  displayName: z.string(),
  signUpTimestamp: TimestampSchema,
})

export type Profile = ZodInfer<typeof ProfileSchema>
